export default "__VITE_ASSET__8deea8c7__"